import React from 'react';
import styled from '@emotion/styled';
import { theme } from '@vimily/bonjoro-ui-components';

export type CtaProps = {
  className?: string;
  text?: string;
  bgColor?: string;
  textColor?: string;
};

const TextContainer = styled.div<
  Required<Pick<CtaProps, 'bgColor' | 'textColor'>>
>`
  background-color: ${(props) => props.bgColor};
  color: ${(props) => props.textColor};
`;

const Cta = ({
  bgColor = theme.colors.yellow[500],
  textColor = theme.colors.black,
  text = 'Watch your video',
  className = '',
}: CtaProps) => {
  return (
    <div className={`w-full pt-2 ${className}`}>
      <div className='mb-4 w-full m-auto'>
        <TextContainer
          bgColor={bgColor}
          textColor={textColor}
          className='h-12 text-[14px] rounded-[5px] font-bold	flex items-center	justify-center'
        >
          {text}
        </TextContainer>
      </div>
    </div>
  );
};

export default Cta;
